var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { LogoutIcon } from '@deliveryhero/armor-icons';
import { HeaderNavigationActionItem } from '@deliveryhero/armor';

var setURL = function setURL() {
  return window.location.assign('/users/sign_out');
};

export var HeaderNavigationActionLogisticsSignOutButton = function HeaderNavigationActionLogisticsSignOutButton(_a) {
  var restProps = __rest(_a, []);

  return React.createElement(HeaderNavigationActionItem, Object.assign({}, restProps, {
    onClick: setURL
  }), React.createElement(LogoutIcon, {
    height: "24px",
    viewBox: "0 4 24 24"
  }));
};